import * as React from "react";

import Image from "next/image";
import Link from "next/link";
import Slider from "react-slick";
import { Grid, makeStyles, Typography } from "@material-ui/core";

import LandImage from "../../../../public/assets/images/c.png";
import { useWindowSize } from "../../../../helpers/hooks";
import ShareBox from "./ShareBox";

// import LandImage from "../../../../public/assets/images/c.png";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "96%",
    margin: "50px auto",
    marginRight: "2px",
    borderRadius: "20px",
    boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
    position: "relative",
  },

  imageContainer: (props) => ({
    position: "absolute",
    marginTop: props.pushTop ? "-100px" : "0",
    width: "102px",
    height: "102px",
    [theme.breakpoints.only("md")]: {
      width: "80px",
      height: "80px",
      top: props.home ? "0" : "-10px",
      left: "calc(50% - 50px)",
    },
    borderRadius: "50%",
    boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
    // transform: 'translate(0, 90px)',
    top: props.home ? "0" : "100px",
    left: "10%",
    margin: "-1.1rem",
    // paddingTop: '10px',
    zIndex: 98,
    backgroundColor: "white",
    "& img": {
      borderRadius: "50%",
      width: "100%",
      height: "100%",
      padding: "3px",
      [theme.breakpoints.only("md")]: {
        borderRadius: "50%",
        width: "100%",
        height: "100%",
      },
    },
  }),
  dataContainer: {
    marginTop: "calc(100px - 4.5vw)",
  },
  organizationName: {
    // padding: "0 8px",
    lineHeight: "2rem",
    maxHeight: "3rem",
    direction: "ltr",
    fontSize: "1.5rem !important",
    fontFamily: "Vazir-Medium",
    marginTop: "40px",
    marginLeft: "-5px",
    textAlign: "center",
    display: "flex",
    width: "100%",
    justifyContent: "center",

    [theme.breakpoints.only("md")]: {
      fontSize: "1.818rem !important",
    },
  },
  container: {
    minWidth: "100%",
    // paddingBottom: '20px',
    maxWidth: "100%",

    borderRadius: "20px !important",
    // paddingTop: '20px',
    "& .attitudes__slider__root": {
      "& .slick-arrow": {
        marginRight: "50px",
        marginLeft: "50px",
        backgroundColor: "#444444aa",
      },
    },
  },
  imgP: {
    width: "100%",
    margin: "10px",
  },
}));

const InfoPart = ({
  data,
  orgData,
  setPaymentData,
  user,
  customClassName,
  ...props
}) => {
  const size = useWindowSize();
  const settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 10000,
    arrows: true,
    rtl: true,
    className: "attitudes__slider__root",
    dots: false,
  };

  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    if (!!data.dedicated_payment_page_description) {
      setShow(true);
    }
  }, [data, data.dedicated_payment_page_description]);

  const classes = useStyles({ size });

  return (
    <div className={classes.root}>
      <div style={{ display: "flex", width: "100%", height: "100%" }}>
        {data ? (
          <Image
            alt={`کاور ${data?.name || ""}`}
            blurDataURL={data?.banner?.length > 1 ? data?.banner : LandImage}
            src={data?.banner?.length > 1 ? data?.banner : LandImage}
            placeholder="blur"
            width={600}
            height={200}
          />
        ) : null}
      </div>
      {data.logo ? (
        <Grid item md={12} className={classes.imageContainer}>
          <Image
            src={data && data.logo}
            alt="logo"
            layout="fill"
            placeholder="blur"
            blurDataURL={data && data.logo}
          />
        </Grid>
      ) : null}

      <Grid container md={12}>
        <Grid item xs={12} sm={12} md={12} className={classes.dataContainer}>
          <div style={{ marginBottom: "24px" }}>
            <Link href={`/organizations/charities/${data?.slug}`}>
              <a className={classes.organizationName}>{data.name}</a>
            </Link>
          </div>
          {data.dedicated_payment_page_gallery?.length > 0 ? (
            <Grid container md={12} className={classes.container}>
              <Slider {...settings}>
                {data.dedicated_payment_page_gallery &&
                  data.dedicated_payment_page_gallery.map((item) => (
                    <div key={item.id} className={classes.imgP}>
                      <Image
                        layout="responsive"
                        width={30}
                        height={15}
                        src={item.url}
                        alt={item.id}
                        className={classes.img}
                      />
                    </div>
                  ))}
              </Slider>
            </Grid>
          ) : null}
          <div>
            {" "}
            <div style={{ display: "flex", justifyContent: "right" }}>
              <Typography
                variant="h5"
                style={{
                  margin: " 24px 35px 0px 5px",
                  fontFamily: "vazir-bold",
                  fontSize: "16px",
                }}
              >
                {data.dedicated_payment_page_title}
              </Typography>
            </div>
            {data &&
            show &&
            data.dedicated_payment_page_description &&
            data?.dedicated_payment_page_description !== "" ? (
              <Typography
                style={{
                  padding: "24px 35px",
                }}
                dangerouslySetInnerHTML={{
                  __html: data.dedicated_payment_page_description,
                }}
              />
            ) : null}
          </div>{" "}
          <ShareBox
            data={data.id}
            slug={data.slug}
            link={data?.dedicated_payment_page_share_link}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default InfoPart;
